// Enhanced to prevent body scrolling when JS is enabled
document.querySelectorAll(".js-mobile-menu-toggle").forEach((elem) => {
  elem.addEventListener("click", function () {
    document.body.classList.toggle("no-scroll");
    document.body.classList.toggle("height-full");
    document.documentElement.classList.toggle("no-scroll");
    document.documentElement.classList.toggle("height-full");
  });
});
